import React from 'react';
import { Helmet } from 'react-helmet';

import { Box, Typography, Card, CardContent } from '@mui/material';
import TaxiAlertIcon from '@mui/icons-material/TaxiAlert';
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import RouteIcon from '@mui/icons-material/Route';

import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import PublicIcon from '@mui/icons-material/Public';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SanitizerIcon from '@mui/icons-material/Sanitizer';
import Phone from '@mui/icons-material/Phone';
const SalemTaxiService = () => {
  return (
    <Box >
  <Helmet>
  <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    
        <meta property="og:site_name" content="SVR Taxi Service | Call us 9965821750" />
        <title>Call us 9965821750 to your taxi</title>
        <meta name="description" content="SVR offers 24/7 (Best) cab and taxi services for airport transfers, city rides, outstation trips in salem and more. Book now at 9965821750 for fast, reliable, and affordable services. Whether you need a cab, taxi, or even a fleet of taxis and cabs, we ensure comfort and timely rides. Call 9965821750 today and enjoy hassle-free trips with SVR cabs and taxi services." />
        <meta name="keywords" content="taxi services, cab services, 24/7 taxi, SVR taxi, airport cab, city taxis, taxi booking, local cabs, online taxi service, affordable cabs, reliable taxis,Cab & Taxi service in salem,Taxi service in salem , Cabs in salem , salemtoyercaud,salemtobangalore,call us 9965821750,Call and Book Ride 9965821750" />
        
        <meta property="og:title" content=" 9965821750 call to book your (Best) Cab/Taxi & Cabs/Taxis Service in salem" />
        <meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://svrtaxi.netlify.app/salem-taxi-service"/>
        <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
        
        <link rel="canonical" href="https://svrtaxi.netlify.app/salem-taxi-service" />
      </Helmet>
      <header style={{marginTop:'30px'}}>
        <h1><strong>Cab Service</strong> - Affordable, Reliable, and Transparent Pricing</h1>
        <p>
          Your trusted taxi service in Salem and across India, with 
          <strong> no extra charges </strong> and a flat rate of 
          <strong> ₹11 per km</strong>. Contact us at 
          <a href="tel:9965821750">9965821750</a> for bookings.
        </p>
      </header>

      <Box className="service-section">
        <h1 style={{ fontSize: 'larger' }}>Our <strong>Cab and Cabs Services</strong></h1>
        
        <Box className="card-container">
          {/* 24/7 Taxi Booking */}
          <Box className="service-card">
            <TaxiAlertIcon style={{ fontSize: 60, color: '#f50057' }} />
            <h3>24/7 <strong>Taxi & Cab Booking Services</strong></h3>
            <p>Enjoy 24/7 cab and taxi services for all your travel needs. Book a taxi or cab anytime, anywhere, with SVR's round-the-clock services.</p>
          </Box>

          {/* Airport Transfers */}
          <Box className="service-card">
            <LocalAirportIcon style={{ fontSize: 60, color: '#3f51b5' }} />
            <h3>Reliable Airport Taxi & Cab Transfers</h3>
            <p>We offer efficient airport transfers to ensure you’re on time. Book a cab or taxi for a hassle-free journey to and from the airport.</p>
          </Box>

          {/* City Tours */}
          <Box className="service-card">
            <LocationCityIcon style={{ fontSize: 60, color: '#ff9800' }} />
            <h3>City Tours with Comfortable Taxis</h3>
            <p>Explore the city with our professional city tour taxi services. Our drivers provide insightful local knowledge for an unforgettable experience.</p>
          </Box>

          {/* Local Taxi Services */}
          <Box className="service-card">
            <DirectionsCarIcon style={{ fontSize: 60, color: '#4caf50' }} />
            <h3><strong>Local Cabs & Taxi Services</strong></h3>
            <p>Need a local taxi or cab? SVR offers affordable local rides, whether for errands, appointments, or a quick city journey.</p>
          </Box>

          {/* Outstation Cabs */}
          <Box className="service-card">
            <RouteIcon style={{ fontSize: 60, color: '#9c27b0' }} />
            <h3>Outstation Cabs & Taxi Services</h3>
            <p>Plan your trip outside the city with our outstation cab services. Book a comfortable taxi for a safe and enjoyable journey beyond the city limits.</p>
          </Box>
        </Box>
      </Box>
      <header>
        <Typography variant="h4" component="h1" gutterBottom>
          SVR Taxi Services - Your 24/7 Trusted Taxi Service
        </Typography>
        <Typography variant="body1">
          Providing reliable taxi services near you across Salem and all over India. Contact us at{' '}
          <a href="tel:9965821750">9965821750</a> for quick, comfortable rides anytime.
        </Typography>
      </header>

      {/* Service Section */}
      <Box className="service-section">
        <Typography variant="h5" component="h2" gutterBottom>
          Our <strong>Cab and Taxi Services</strong>
        </Typography>

        <Box display="flex" flexWrap="wrap" justifyContent="center" gap={4}>
          {/* 24/7 Taxi Booking */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <LocalTaxiIcon sx={{ fontSize: 48, color: '#1976d2' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                24/7 <strong>Taxi & Cab Booking Services</strong>
              </Typography>
              <Typography>
                Enjoy 24/7 cab and taxi services for all your travel needs. Book a taxi or cab anytime, anywhere, with SVR's round-the-clock services.
              </Typography>
            </CardContent>
          </Card>

          {/* Airport Transfers */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <FlightTakeoffIcon sx={{ fontSize: 48, color: '#ff8f00' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                Reliable Airport Taxi & Cab Transfers
              </Typography>
              <Typography>
                We offer efficient airport transfers to ensure you’re on time. Book a cab or taxi for a hassle-free journey to and from the airport.
              </Typography>
            </CardContent>
          </Card>

          {/* City Tours */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <LocationCityIcon sx={{ fontSize: 48, color: '#2e7d32' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                City Tours with Comfortable Taxis
              </Typography>
              <Typography>
                Explore the city with our professional city tour taxi services. Our drivers provide insightful local knowledge for an unforgettable experience.
              </Typography>
            </CardContent>
          </Card>

          {/* Local Taxi Services */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <DirectionsCarIcon sx={{ fontSize: 48, color: '#d32f2f' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                <strong>Local Cabs & Taxi Services</strong>
              </Typography>
              <Typography>
                Need a local taxi or cab? SVR offers affordable local rides, whether for errands, appointments, or a quick city journey.
              </Typography>
            </CardContent>
          </Card>

          {/* Outstation Cabs */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <PublicIcon sx={{ fontSize: 48, color: '#388e3c' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                Outstation Cabs & Taxi Services
              </Typography>
              <Typography>
                Plan your trip outside the city with our outstation cab services. Book a comfortable taxi for a safe and enjoyable journey beyond the city limits.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>

      {/* Existing Services Section */}
      <Box className="service-section">
        <Typography variant="h5" component="h2" gutterBottom>
          Find the Best Taxi Service Near You - Available Across Salem and Beyond
        </Typography>
        <Typography>
          SVR Taxi Services offers round-the-clock <strong>taxi service near you</strong> in Salem and throughout India. Whether you need a local cab for
          short distances or a taxi for a long trip, we are here to make your journey seamless. With our professional drivers and well-maintained fleet, we
          ensure every ride is comfortable, safe, and on time.
        </Typography>

        <Box display="flex" flexWrap="wrap" justifyContent="center" gap={4} mt={4}>
          {/* Local Taxi Services Near Me */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <DirectionsCarIcon sx={{ fontSize: 48, color: '#1976d2' }} />
              <Typography variant="h6" component="h1" gutterBottom>
                <strong>Local Taxi Services Near Me</strong>
              </Typography>
              <Typography>
                Need a quick ride around town? Our local taxi service is ideal for short distances within Salem or nearby areas. Available 24/7 for your
                convenience.
              </Typography>
            </CardContent>
          </Card>

          {/* Outstation Taxi Services */}
          <Card className="service-card" sx={{ maxWidth: 300 }}>
            <CardContent>
              <PublicIcon sx={{ fontSize: 48, color: '#388e3c' }} />
              <Typography variant="h6" component="h3" gutterBottom>
                Outstation Taxi Services Across India
              </Typography>
              <Typography>
                Planning a trip outside Salem? Our outstation taxi service covers routes across India, providing comfortable rides for all your travel needs.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Box>

      <Box className="why-choose">
      <Typography variant="h4" component="h2" gutterBottom>
        Why Choose SVR Cab & Taxi Service?
      </Typography>

      <Box display="flex" flexWrap="wrap" justifyContent="center" gap={4}>
        {/* Experienced Drivers */}
        <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <DirectionsCarIcon sx={{ fontSize: 48, color: '#1976d2' }} />
            <Typography variant="h5" component="h3" gutterBottom>
              Experienced Taxi & Cab Drivers
            </Typography>
            <Typography>
              Our drivers are trained and knowledgeable, ensuring safe, comfortable rides every time you choose SVR’s taxi or cab services.
            </Typography>
          </CardContent>
        </Card>

        {/* Affordable Pricing */}
        <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <AttachMoneyIcon sx={{ fontSize: 48, color: '#2e7d32' }} />
            <Typography variant="h5" component="h3" gutterBottom>
              Affordable Pricing on All Cabs
            </Typography>
            <Typography>
              Enjoy affordable taxi services without compromising on quality. Our pricing is competitive for both local cabs and outstation taxis.
            </Typography>
          </CardContent>
        </Card>

        {/* 24/7 Availability */}
        <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <AccessTimeIcon sx={{ fontSize: 48, color: '#ff8f00' }} />
            <Typography variant="h5" component="h3" gutterBottom>
              24/7 Availability for Cabs and Taxis
            </Typography>
            <Typography>
              We’re available around the clock for your convenience. Call us anytime at <a href="tel:9965821750">9965821750</a> for 24/7 taxi or cab services.
            </Typography>
          </CardContent>
        </Card>

        {/* Easy Booking */}
        <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <CheckCircleOutlineIcon sx={{ fontSize: 48, color: '#d32f2f' }} />
            <Typography variant="h5" component="h3" gutterBottom>
              Simple and Easy Taxi Booking
            </Typography>
            <Typography>
              Book your cab or taxi with ease through our website or a quick phone call. Just tell us your destination, and we’ll handle the rest!
            </Typography>
          </CardContent>
        </Card>

       

        {/* Safe and Clean Vehicles */}
        <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <SanitizerIcon sx={{ fontSize: 48, color: '#388e3c' }} />
            <Typography variant="h5" component="h3" gutterBottom>
              Safe & Clean Taxis and Cabs
            </Typography>
            <Typography>
              SVR ensures all cabs are regularly sanitized and well-maintained, so you enjoy a safe, comfortable, and clean ride every time.
            </Typography>
          </CardContent>
        </Card>

         {/* Safe and Clean Vehicles */}
         <Card className="feature-card" sx={{ maxWidth: 300 }}>
          <CardContent>
            <Phone fontSize="large" sx={{ color: "#2196f3",fontSize: 48  }} />
            <Typography variant="h1" component="h1" gutterBottom sx={{fontSize:20}}>
            9965821750 call to book ride
            </Typography>
            <Typography>
              Just call 9965821750 to book your ride with in 1 minutes , it will very usefull for customers book the ride easily and efficient.
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Box> <footer>
        <h1 style={{fontSize:'larger'}}>Contact SVR Cab & Taxi Service</h1>
        <p>Call us anytime at <a href="tel:9965821750">9965821750</a> or book online at <a href="https://svrtaxi.netlify.app" target="_blank" rel="noopener noreferrer">svrtaxi.netlify.app</a>.</p>
      </footer>
    </Box>
  );
};

export default SalemTaxiService;
